import React, { Component } from 'react'

class TripReport extends Component {
  render() {
    return (
      <div>TripReport</div>
    )
  }
}

export default TripReport